import React, { Component, Fragment } from 'react';
import './style.scss';

export default class About extends Component {
    constructor(props) {
        super(props);
        var data = require('./data/' + this.props.shortname + '.js');
        this.state = {
            data,
        };
    }
    render() {
        const { shortname } = this.props;
        const { data } = this.state;
        const isESGPage = data.content.lowerTitle === 'Our ESG Stories';
        return (
            <Fragment>
                <ul className="split-about white">
                    <li className={'is-sticky ' + shortname}></li>
                    <li>{data.content.body()}</li>
                </ul>
                {data.content.lowerTitle && data.content.lowerItems ? (
                    <ul className={`split-about black ${isESGPage && 'esg-stories'}`}>
                        <li>{data.content.lowerTitle}</li>
                        {isESGPage && (
                            <div className="scroll esg-stories-scroll">
                                <span></span>
                                <span></span>
                                <span></span>
                            </div>
                        )}
                        {data.content.lowerItems.map((item, key) => (
                            <li key={key}>
                                <a
                                    href={item.url}
                                    title={item.content}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                >
                                    <p>{item.content}</p>
                                </a>
                            </li>
                        ))}
                        <div className="scroll black">
                            <span></span>
                            <span></span>
                            <span></span>
                        </div>
                    </ul>
                ) : null}
            </Fragment>
        );
    }
}
